import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import "../../Styles/Header.css";
import Appbar from "../../Component/NavPannel/Appbar";
import InvestorManagementLayout from "../../Component/Layouts/InvestorManagementLayout";

const mdTheme = createTheme();

function Investor() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex", height: "100vh" }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Investors Management" />
        <InvestorManagementLayout />
      </Box>
    </ThemeProvider>
  );
}

export default function InvestorManagement() {
  return <Investor />;
}
